import { render } from "./InterfaceButton.vue?vue&type=template&id=53ab852c&scoped=true"
import script from "./InterfaceButton.vue?vue&type=script&lang=js"
export * from "./InterfaceButton.vue?vue&type=script&lang=js"

import "./InterfaceButton.vue?vue&type=style&index=0&id=53ab852c&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ab852c"]])

export default __exports__